var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suggestions"},[_c('el-tabs',[_c('el-tab-pane',{staticClass:"records",attrs:{"label":"New data"}},[_c('headers'),_vm._v(" "),_c('rows')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Admin suggestions"}},[_c('suggested')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-707fad7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suggestions/Suggestions.vue
// module id = null
// module chunks = 